import { render, staticRenderFns } from "./examViewVipPartner.vue?vue&type=template&id=766c0670&scoped=true"
import script from "./examViewVipPartner.vue?vue&type=script&lang=js"
export * from "./examViewVipPartner.vue?vue&type=script&lang=js"
import style0 from "./examViewVipPartner.vue?vue&type=style&index=0&id=766c0670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766c0670",
  null
  
)

export default component.exports